/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


/*  
    Product Images module. 
    This module reloads product images user makes selections.
*/

define('modules/Product/ProductImage',[
    'jquery',
    'global/all',
    'plugins/imagesloaded.pkgd.min',
    'plugins/jquery.zoomswap'
], function ($, Roc, imagesLoaded) {
    'use strict';

    var packagePath = window.RocConfig.cms.packagePath;

    function initImageEnlarge() {
        var imageControls = $('.product-image-controls');
        var enlargeView = $('#enlarge-view-modal');
        var imageContrainer = enlargeView.find('.roc-productImage-large');
        var initImageSrc = imageContrainer.data('rocSrc');
        var imageLarge = imageContrainer.find('img');

        if (imageLarge.length <= 0) {
            imageContrainer.append('<img src="' + initImageSrc + '" alt="" />');
        };

        imageControls.on('click', '#enlarge-view-button', function (e) {
            Roc.UI.Modal.open('#enlarge-view-modal');
        });
    };

    function initMainProductImage() {
        var $mainProductImage = $('.productImage');
        var regularPath = $mainProductImage.data('zoomswapRpath');
        var largePath = $mainProductImage.data('zoomswapZpath');

        Roc.UI.siteBody
            .off('click', '.altViews li a')
            .on('click', '.altViews li a', function () {
                var newimg = $(this).attr('href');

                //update active status
                var altViews = $('.altViews li');
                altViews.each(function (i) {
                    var children = altViews.eq(i).children('a');
                    children.each(function (j) {
                        if (newimg.replace('/' + largePath + '/', '').replace('/' + regularPath + '/', '') === children.eq(j).attr('href').replace('/' + largePath + '/', '').replace('/' + regularPath + '/', '')) {
                            children.eq(j).addClass('active');
                        } else {
                            children.eq(j).removeClass('active');
                        }
                    });
                });

                $('.productImage img.mainImage').attr({ src: newimg });
                $('#enlarge-view-modal .roc-productImage-large img').attr({ src: newimg.replace('/' + regularPath + '/', '/' + largePath + '/') });

                return false;
            });

        $('.zoom-swap').each(function () {
            var cont = $(this);
            var imageCont = cont.zoomSwap({
                trigger: $('.product-image-controls .icon-zoom-in'),
                reset: $('.product-image-controls .icon-refresh, .product-image-controls .icon-zoom-out'),
                zoomMethod: 'hover',
                zoomInverse: true,
                rPath: regularPath,
                zPath: largePath
            });
        });

        initImageEnlarge();
    };

    function initImagesLoaded() {
        var $productImages = $('.site-container .roc-image-product');
        var imgLoad = imagesLoaded($productImages);

        imgLoad.on('progress', function (instance, image) {
            var result = image.isLoaded ? 'loaded' : 'broken';
            if (result === 'broken') {
                Roc.Logger.warn('Image Broken: ' + image.img.src);

                var naImage = packagePath + '/assets/images/na-images/na-l.svg',
                    $brokenImage = $(image.img);

                if ($brokenImage.data('rocDimensionKey')) {
                    naImage = packagePath + '/assets/images/na-images/na-' + $brokenImage.data('rocDimensionKey') + '.svg';
                };

                // change broken image src with spacer.gif and apply broken image class
                $brokenImage.attr('data-roc-original-image', image.img.src);
                image.img.src = naImage;

                $brokenImage.addClass('roc-image-na');
            };
        });
    };

    function reloadProductImages(viewModel) {
        if (!viewModel || !viewModel.images) {
            return;
        }

        var altViews = document.getElementsByClassName('altViews');

        if (altViews && altViews.length > 0) {
            altViews[0].innerHTML = '';
        }

        var enlargeModal = document.getElementById("enlarge-view-modal");
        var altViewsModal;

        if (enlargeModal) {
            altViewsModal = enlargeModal.getElementsByClassName("altViews");
            if (altViewsModal && altViewsModal.length > 0) {
                altViewsModal[0].innerHTML = '';
            }
        }

        if (viewModel.images && viewModel.images.length === 0) {
            $('.productImage .mainImage').attr('src', packagePath + '/assets/images/na-images/na-l.svg');
            $('#enlarge-view-modal .roc-productImage-large img').attr({ src: packagePath + '/assets/images/na-images/na-l.svg' });
            return;
        }

        $('.productImage .mainImage').attr('src', Roc.Core.getImageUrl(viewModel.images[0], 458, 458));
        $('#enlarge-view-modal .roc-productImage-large img').attr({ src: Roc.Core.getImageUrl(viewModel.images[0], 458, 458) });

        for (var i = 0; i < viewModel.images.length; i++) {
            var altViewAnchor = document.createElement('a');

            altViewAnchor.setAttribute('href', Roc.Core.getImageUrl(viewModel.images[i], 458, 458));

            var altViewImg = document.createElement('img');

            altViewImg.setAttribute('src', Roc.Core.getImageUrl(viewModel.images[i], 60, 60));
            altViewImg.setAttribute('style', 'width: 60px; height: 60px;');
            altViewImg.setAttribute('class', 'roc-image-product');
            altViewAnchor.appendChild(altViewImg);

            var listItem = document.createElement('li');

            listItem.appendChild(altViewAnchor);
            altViews[0].appendChild(listItem);

            if (altViewsModal && altViewsModal.length > 0) {
                var listItemModal = listItem.cloneNode(true);
                altViewsModal[0].appendChild(listItemModal);
            }
        }
    }

    function init() {
        initMainProductImage();
        Roc.EventManager.bind(Roc.Events.products.SELECTIONS_UPDATE, reloadProductImages);
    }

    var ProductImage = {
        init: init,
        initImagesLoaded: initImagesLoaded,
        initMainProductImage: initMainProductImage
    }

    Roc.Logger.debug('ProductImage.js Loaded:', ProductImage);

    return ProductImage;
});
